import { useEffect, useMemo } from 'react';

const useFilteredDivisionsTabs = (
    tabValue,
    setTabValue,
    isLoadingDivisions,
    divisions,
    divisionsFilter
) => {
    const filteredDivisions = useMemo(() => {
        if (!divisionsFilter || !divisionsFilter?.length) return divisions;
        return divisions?.filter((division) => divisionsFilter.includes(division.description));
    }, [divisionsFilter, divisions]);

    useEffect(() => {
        if (isLoadingDivisions) return;

        const selectedTabData = filteredDivisions?.find(
            (division) => division.description === tabValue
        );
        // handle the case where the tabValue is not a valid division
        if ((!tabValue || (tabValue && !selectedTabData)) && filteredDivisions?.[0]?.description) {
            setTabValue(filteredDivisions[0].description);
        }
    }, [tabValue, setTabValue, isLoadingDivisions, filteredDivisions]);

    const { validTabValue = false, validTabkey } = useMemo(() => {
        if (isLoadingDivisions || !tabValue || !filteredDivisions?.length) return false;
        const selectedTabData = filteredDivisions?.find(
            (division) => division.description === tabValue
        );
        // avoid returning the tabValue if it is not a valid division
        return {
            validTabValue: selectedTabData ? tabValue : false,
            validTabkey: selectedTabData ? selectedTabData.name : false,
        };
    }, [isLoadingDivisions, tabValue, filteredDivisions]);

    return { selectedTabValue: validTabValue, selectedTabKey: validTabkey, filteredDivisions };
};

export default useFilteredDivisionsTabs;
